
import { motion } from 'framer-motion';

const TrustIndicators = () => {
  const indicators = [
    '15+ Years PMO Leadership',
    'Government & Enterprise Delivery',
    'ISO & Audit-Ready Frameworks',
  ];

  return (
    <section className="bg-warm-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12"
        >
          {indicators.map((indicator, index) => (
            <div key={index} className="flex items-center">
              <p className="font-inter text-sm text-charcoal/50 text-center whitespace-nowrap">
                {indicator}
              </p>
              {index < indicators.length - 1 && (
                <div className="hidden md:block w-px h-8 bg-taupe/30 ml-12"></div>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustIndicators;
